import React from "react";
import { RouteComponentProps } from "react-router";

import FileViewer from "../FileViewer";

import { V2 } from "../../Api";
import withTitle from "../withTitle";
import ProgressBar from "../ProgressBar";

interface IDocumentViewProps extends RouteComponentProps<any> {
    fileId?: string;
}

interface IDocumentViewState {
    isLoading: boolean | string;
    loadPercent: number;

    mime: string;
    url: string;
    filename: string;
}

class DocumentView extends React.Component<IDocumentViewProps, IDocumentViewState> {
    constructor(props: Readonly<IDocumentViewProps>) {
        super(props);

        const state: IDocumentViewState = {
            isLoading: true,
            loadPercent: 0,

            mime: "",
            url: "",
            filename: "",
        };

        this.state = state;
    }

    public componentDidMount() {
        this.loadDocument();
    }

    public componentWillUnmount() {
        if (this.state.url) {
            URL.revokeObjectURL(this.state.url);
        }
    }

    public render() {
        if (typeof this.state.isLoading === "string") {
            return <div className="viewer-root">
                <div className="error-box">{this.state.isLoading}</div>
            </div>;
        }

        if (this.state.isLoading === true) {
            return <div className="viewer-root spinner-full-root">
                <h3><span className="spinner lds-dual-ring-small" />&nbsp;Loading file...</h3>
                <ProgressBar className="progress-bar-300" value={this.state.loadPercent} />
            </div>;
        }

        return (
            <FileViewer url={this.state.url} mime={this.state.mime} filename={this.state.filename} className="file-viewer file-viewer-full">
                {this.props.children}
            </FileViewer>
        );
    }

    private async loadDocument() {
        try {
            this.setState({
                isLoading: true
            });

            const fileId = this.props.fileId || this.props.match.params.file_id;

            const [fileInfo, document] = await Promise.all([
                V2.get<any>(`files/${fileId}/metadata`),
                V2.get<Blob>(`files/${fileId}`, (current, total) => {
                    this.setState({
                        loadPercent: (current * 100 / total)
                    });
                }),
            ]);
            const blob = URL.createObjectURL(document);

            this.setState({
                isLoading: false,

                mime: document.type,
                url: blob,
                filename: fileInfo.filename
            });
        }
        catch (e) {
            this.setState({
                isLoading: e.message || e || "Could not load documents"
            });
        }
    }

}

export default withTitle("View Document", DocumentView);
